export const dataTestIds = {
  component: {
    actions: {
      button: {
        showMore: 'table-button-show-more',
      },
    },

    assistant: {
      chatBox: 'assistant-chat-box',
      chatContent: 'assistant-chat-content',
      chatHeader: 'assistant-chat-header',
      closedButton: 'assistant-closed-button',
      speechBubble: 'assistant-speech-bubble-text',
    },

    contentCard: {
      self: 'content-card',
    },

    header: {
      logo: 'logo',
      userMenu: 'user-menu',
    },

    multiCollapsable: {
      self: 'multi-collapsable-self',
    },

    pagination: {
      button: {
        next: 'pagination-button-next',
        number: 'pagination-button-number',
        previous: 'pagination-button-previous',
      },
      text: {
        endItemCurrentSelection: 'pagination-text-end-item-current-selection',
        startItemCurrentSelection:
          'pagination-text-start-item-current-selection',
        totalItems: 'pagination-text-total-items',
      },
    },

    searchBar: {
      button: {
        clear: 'clear-searchbar',
      },
    },

    slideviewer: {
      slide: {
        button: {
          left: 'slideviewer-slide-button-left',
          right: 'slideviewer-slide-button-right',
          submitMultipleChoiceAnswer:
            'slideviewer-slide-button-submit-multiple-choice-question',
          submitOpenQuestion: 'slideviewer-slide-button-submit-open-question',
        },

        input: {
          openQuestion: 'slideviewer-slide-input-open-question',
        },
      },

      viewModes: {
        button: {
          classical: 'slideviewer-view-modes-classical',
          multiscreen: 'slideviewer-view-modes-multiscreen',
          projection: 'slideviewer-view-modes-projection',
          selfstudy: 'slideviewer-view-modes-selfstufy',
          showViewmode: 'slideviewer-view-modes-show',
        },
      },
    },

    stats: {
      amount: 'stats-amount',
      name: 'state-name',
    },

    subjectCard: {
      button: {
        downloadDocument: 'subject-card-button-download-document',
      },
      self: 'subject-card',
      text: {
        badges: 'subject-card-text-badges',
        title: 'subject-card-text-title',
      },
    },

    table: {
      empty: 'table-empty',
    },
  },

  modal: {
    slideQuestionConfirmationModal: {
      button: {
        cancel: 'slide-question-confirmation-modal-button-cancel',
        submit: 'slide-question-confirmation-modal-button-submit',
      },

      self: 'slide-question-confirmation-modal',
    },

    stats: {
      amount: 'stats-amount',
      name: 'state-name',
    },
  },
};
